'use client';

import { useState, useEffect } from 'react';
import { Box, Stack, Divider } from '@mui/material';
import WalletStatusMessages from './components/WalletStatusMessages';
import AvailableBalanceCard from './components/AvailableBalanceCard';
import BlockedAmountCard from './components/BlockedAmountCard';
import TransactionHistory from './components/TransactionHistory';
import AddMoneyDialog from './components/AddMoneyDialog';
import BlockedAmountInfoDialog from './components/BlockedAmountInfoDialog';
import useWalletTransactions from './hooks/useWalletTransactions';

export default function WalletSection({ wallet, onAddMoney, loading, error, status, onRefresh }) {
  const [addMoneyOpen, setAddMoneyOpen] = useState(false);
  const [showBlockedInfo, setShowBlockedInfo] = useState(false);
  const {
    transactions,
    loading: txnLoading,
    refresh,
    page,
    totalPages,
    goToPage,
    filter,
    setFilter,
    dateRange,
    setDateRange,
    totalCount,
  } = useWalletTransactions();

  // CRITICAL FIX: Auto-refresh transactions when wallet balance changes
  // This ensures transactions list updates immediately after payment
  useEffect(() => {
    if (wallet?.available !== undefined || wallet?.blocked !== undefined) {
      refresh();
    }
  }, [wallet?.available, wallet?.blocked, refresh]);

  const handleAddMoney = (amount) => {
    if (onAddMoney) {
      onAddMoney(amount);
    }
    setAddMoneyOpen(false);
  };

  return (
    <Box>
      <WalletStatusMessages status={status} error={error} />

      <Stack spacing={2} mb={3}>
        <AvailableBalanceCard
          balance={wallet.available}
          onAddMoney={() => setAddMoneyOpen(true)}
          onRefresh={onRefresh}
          loading={loading}
        />
        <BlockedAmountCard amount={wallet.blocked} onShowInfo={() => setShowBlockedInfo(true)} />
      </Stack>

      <Divider sx={{ my: 3 }} />

      <TransactionHistory
        transactions={transactions}
        loading={txnLoading}
        filter={filter}
        onFilterChange={setFilter}
        dateRange={dateRange}
        onDateRangeChange={setDateRange}
        onRefresh={refresh}
        page={page}
        totalPages={totalPages}
        onPageChange={goToPage}
        totalCount={totalCount}
      />

      {/* Add Money dialog — Razorpay opens automatically (UPI or card/netbanking) */}
      <AddMoneyDialog
        open={addMoneyOpen}
        onClose={() => setAddMoneyOpen(false)}
        onAdd={handleAddMoney}
      />

      <BlockedAmountInfoDialog open={showBlockedInfo} onClose={() => setShowBlockedInfo(false)} />
    </Box>
  );
}
